import { render } from "./MyRaces.vue?vue&type=template&id=4d03b5b0&ts=true"
import script from "./MyRaces.vue?vue&type=script&lang=ts"
export * from "./MyRaces.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__